<template>
	<!--  stepper -->
	<v-stepper v-model="stepper" class="elevation-12">
		<v-btn absolute fab text small @click="closeDialog" style="top: -5px; right: -5px">
			<v-icon>mdi-close</v-icon>
		</v-btn>
		<v-stepper-header>
			<v-stepper-step :complete="stepper > 1" step="1">
				Nombre del documento
			</v-stepper-step>
			<v-divider></v-divider>
			<v-stepper-step :complete="stepper > 2" step="2">
				Seleccion un documento
			</v-stepper-step>
		</v-stepper-header>
		<v-stepper-items>
			<v-stepper-content step="1">
				<v-text-field
					class="ma-2"
					v-model="filename"
					dense
					filled
					outlined
					label="Nombre del documento"
					hint="*optional"
					persistent-hint
				>
					<template v-slot:append v-if="filename">
						<v-slide-x-reverse-transition mode="out-in">
							<v-icon color="success">
								mdi-check-outline
							</v-icon>
						</v-slide-x-reverse-transition>
					</template>
				</v-text-field>
			</v-stepper-content>
			<v-stepper-content step="2" class="px-2">
				<v-file-input
					class="mt-2"
					v-model="file"
					label="Seleccione un documento"
					hint="*requerido"
					persistent-hint
					outlined
					dense
					multiple
				>
				</v-file-input>
			</v-stepper-content>
			<v-footer v-if="file">
				<v-btn small block color="warning" :loading="loading" @click="onSubmit">
					Subir
					<v-icon>mdi-upload-outline</v-icon>
				</v-btn>
			</v-footer>
			<v-footer>
				<v-row>
					<v-col cols="6">
						<v-btn
							block
							small
							color="primary"
							@click="stepper = 1"
							:disabled="stepper == 1"
						>
							<v-icon>mdi-chevron-left</v-icon>
						</v-btn>
					</v-col>
					<v-col cols="6">
						<v-btn
							:disabled="stepper == 2"
							block
							small
							color="primary"
							@click="stepper = 2"
						>
							<v-icon>
								mdi-chevron-right
							</v-icon>
						</v-btn>
					</v-col>
				</v-row>
			</v-footer>
		</v-stepper-items>
	</v-stepper>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	props: {
		id: {
			type: String,
			default: '',
		},
		close: {
			type: Function,
			required: true,
		},
		viewFinal: {
			type: Function,
			required: true,
		},
	},
	data() {
		return {
			stepper: 1,
			filename: '',
			file: null,
			loading: false,
		};
	},
	methods: {
		async onSubmit() {
			this.loading = true;
			await this.uploadDocument({
				_id: this.id,
				filename: this.filename,
				documents: [...this.file],
			});
			this.closeDialog();
			this.loading = false;
			this.viewFinal();
		},
		closeDialog() {
			this.stepper = 1;
			this.file = null;
			this.filename = '';
			this.close();
		},
		...mapActions({
			uploadDocument: 'Lodging/uploadDocument',
		}),
	},
};
</script>

<style lang="scss" scoped></style>
